import { isNavigationFailure, NavigationFailureType, } from "vue-router";
import router from "@/router";
import { logger } from "@/infrastructure/services/LoggerService";
const SUPPORTED_ERROR_CODES = new Set(["403", "500", "502", "503", "504"]);
/**
 * `.catch` handler for `router.push`/`router.replace` calls that don't await
 * the result. Suppresses the "expected" navigation failures — duplicated
 * navigations (Vue Router resolves them in 4.1+ but the promise still settles)
 * and guard-cancelled navigations (e.g. the unsaved-changes flow). Anything
 * else gets logged so genuine breakage isn't silenced.
 *
 * R47: silent catches must call `logger.error()`.
 */
export function handleNavigationFailure(context) {
    return (err) => {
        if (isNavigationFailure(err, NavigationFailureType.duplicated | NavigationFailureType.cancelled)) {
            return;
        }
        logger.error(`${context}: navigation failed`, err);
    };
}
/**
 * Push the user to the error view for a specific HTTP status. Use from axios
 * interceptors / route guards. Unknown / unsupported codes fall back to 500 so
 * the URL always lands on a page the view knows how to render.
 */
export function redirectToError(code = 500) {
    const str = String(code);
    const final = SUPPORTED_ERROR_CODES.has(str)
        ? str
        : "500";
    router.push(`/error/${final}`).catch(handleNavigationFailure("redirectToError"));
}
